import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useState } from "react";

const NAV = [
  { to:"/",          icon:"📊", label:"Dashboard"   },
  { to:"/revenue",   icon:"📈", label:"Revenue"     },
  { to:"/cashflow",  icon:"💰", label:"Cashflow"    },
  { to:"/inventory", icon:"📦", label:"Inventory"   },
  { to:"/okrs",      icon:"🎯", label:"OKRs"        },
  { to:"/customers", icon:"👥", label:"Customers"   },
  { to:"/orders",    icon:"🛒", label:"Orders"      },
  { to:"/products",  icon:"🧵", label:"Products"    },
  { to:"/capex",     icon:"🔧", label:"CapEx/OpEx"  },
];

const BACK_OFFICE = [
  { to:"/admins",  icon:"🔐", label:"Admins"     },
  { to:"/zoho",    icon:"🔗", label:"Zoho Books" },
  { to:"/shopify", icon:"🛍️", label:"Shopify"    },
  { to:"/meta",    icon:"📣", label:"Meta Ads"   },
];

const B    = "#2C1A0E";
const ROSE = "#C9847A";

export default function Sidebar() {
  const { user, logout } = useAuth();
  const navigate         = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [boOpen,    setBoOpen]    = useState(false);
  const isOwner = user?.role === "owner";

  const W = collapsed ? 56 : 220;

  const linkStyle = ({ isActive }, indent = false) => ({
    display: "flex", alignItems: "center",
    gap: 10,
    padding: collapsed ? "10px 0" : `9px 18px 9px ${indent ? "28px" : "18px"}`,
    justifyContent: collapsed ? "center" : "flex-start",
    textDecoration: "none",
    background: isActive ? "rgba(201,132,122,0.18)" : "transparent",
    borderLeft: isActive ? `3px solid ${ROSE}` : "3px solid transparent",
    color: isActive ? "#FAF7F2" : `rgba(250,247,242,${indent ? 0.5 : 0.65})`,
    fontSize: indent ? 12 : 13,
    transition: "all 0.15s",
  });

  return (
    <div style={{
      width: W, minHeight: "100vh", background: B,
      display: "flex", flexDirection: "column",
      transition: "width 0.2s", overflow: "hidden",
      flexShrink: 0,
    }}>
      {/* Brand */}
      <div style={{ padding: collapsed ? "20px 0" : "24px 20px 16px",
                    display: "flex", alignItems: "center",
                    justifyContent: collapsed ? "center" : "space-between" }}>
        {!collapsed && (
          <div>
            <div style={{ fontFamily: "'Cormorant Garamond',Georgia,serif",
                          color: "#FAF7F2", fontSize: 17, fontWeight: 700 }}>
              Embroideary
            </div>
            <div style={{ color: ROSE, fontSize: 10, letterSpacing: 1 }}>FY27 PANEL</div>
          </div>
        )}
        {collapsed && <span style={{ fontSize: 20 }}>🪡</span>}
        <button onClick={() => setCollapsed(c => !c)} style={{
          background: "none", border: "none", color: "#FAF7F2",
          cursor: "pointer", fontSize: 14, padding: 4, opacity: 0.6,
        }}>{collapsed ? "›" : "‹"}</button>
      </div>

      {/* Main nav */}
      <nav style={{ flex: 1, padding: "8px 0" }}>
        {NAV.map(n => (
          <NavLink key={n.to} to={n.to} end={n.to === "/"} style={p => linkStyle(p)}>
            <span style={{ fontSize: 16, flexShrink: 0, lineHeight: 1 }}>{n.icon}</span>
            {!collapsed && <span style={{ fontWeight: 500 }}>{n.label}</span>}
          </NavLink>
        ))}

        {/* Back Office — owners only */}
        {isOwner && (
          <>
            <div style={{ margin: collapsed ? "10px 0" : "10px 18px 0",
                          borderTop: "1px solid rgba(255,255,255,0.08)" }} />
            {!collapsed && (
              <button onClick={() => setBoOpen(o => !o)} style={{
                display: "flex", alignItems: "center", justifyContent: "space-between",
                width: "100%", padding: "7px 18px",
                background: "none", border: "none", cursor: "pointer",
                color: "rgba(250,247,242,0.35)", fontSize: 10,
                fontWeight: 700, letterSpacing: 1.5, textTransform: "uppercase",
              }}>
                <span>Back Office</span>
                <span>{boOpen ? "▲" : "▼"}</span>
              </button>
            )}
            {(boOpen || collapsed) && BACK_OFFICE.map(n => (
              <NavLink key={n.to} to={n.to} style={p => linkStyle(p, !collapsed)}>
                <span style={{ fontSize: 15, flexShrink: 0, lineHeight: 1 }}>{n.icon}</span>
                {!collapsed && <span>{n.label}</span>}
              </NavLink>
            ))}
          </>
        )}
      </nav>

      {/* User / logout */}
      <div style={{ padding: collapsed ? "12px 0" : "12px 18px",
                    borderTop: "1px solid rgba(255,255,255,0.08)",
                    display: "flex", flexDirection: "column",
                    alignItems: collapsed ? "center" : "stretch", gap: 8 }}>
        {!collapsed && user && (
          <div>
            <div style={{ color: "#FAF7F2", fontSize: 12, fontWeight: 600 }}>{user.name}</div>
            <div style={{ color: ROSE, fontSize: 10, textTransform: "capitalize" }}>{user.role}</div>
          </div>
        )}
        <button onClick={() => { logout(); navigate("/login"); }} style={{
          background: "rgba(255,255,255,0.07)", border: "none", borderRadius: 7,
          padding: collapsed ? "8px" : "7px 14px",
          color: "rgba(250,247,242,0.6)", fontSize: 12, cursor: "pointer",
          display: "flex", alignItems: "center", justifyContent: "center", gap: 6,
        }}>
          <span>↩</span>
          {!collapsed && <span>Logout</span>}
        </button>
      </div>
    </div>
  );
}
